import { render, staticRenderFns } from "./cashRecordsDetail.vue?vue&type=template&id=0085998d&scoped=true"
import script from "./cashRecordsDetail.vue?vue&type=script&lang=js"
export * from "./cashRecordsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085998d",
  null
  
)

export default component.exports